import React from 'react';
import {makeStyles} from '@material-ui/core/styles';
import {Typography, Divider} from '@material-ui/core';
import BoxOpcoes from '../../../shared/boxopcoes/BoxOpcoes.jsx';
import LabelValue from '../../../shared/labelvalue/LabelValue.js';
import {useContextoResumoValor} from './ContextoResumoInscricao.jsx';
import {calcularIndicadoresRendaInscricao, formatCpfMasked} from '../../../../utils';

const useStyles = makeStyles(theme => ({
    marginBottom: {
        marginBottom: theme.spacing(2)
    },
    divider: {
        margin: theme.spacing(2, 0)
    }
}));

export default function BoxResumoInscricao({inscricaoFallback}) {
    const classes = useStyles();
    const contextoResumo = useContextoResumoValor();
    const data = contextoResumo || inscricaoFallback;

    const {
        rendaFamiliarBruta,
        rendaAgregada,
        rendaBrutaTotal,
        totalIntegrantes,
        rendaPerCapita
    } = calcularIndicadoresRendaInscricao(data);

    return (
        <BoxOpcoes title='Resumo da Inscrição' stretchHeight={false}>
            <div className={classes.marginBottom}>
                <LabelValue label='Candidato'>
                    <Typography variant="body1">
                        <strong>Nome:</strong> {data.pessoa?.nome || 'Não preenchido'} <br/>
                        {data.pessoa?.nomeSocial && (
                            <>
                                <strong>Nome Social:</strong> {data.pessoa.nomeSocial} <br/>
                            </>
                        )}
                        <strong>Nome da Mãe:</strong> {data.pessoa?.nomeMae || 'Não preenchido'} <br/>
                        <strong>CPF:</strong> {formatCpfMasked(data.pessoa?.cpf)} <br/>
                        <strong>E-mail:</strong> {data.pessoa?.emailAtual || 'Não preenchido'}
                    </Typography>
                </LabelValue>
            </div>
            <Divider className={classes.divider} />
            <div className={classes.marginBottom}>
                <LabelValue label='Indicadores Socioeconômicos'>
                    <Typography variant="body1">
                        <strong>Declaração IR:</strong> {data.declaracaoIR === 'S' ? 'Sim' : data.declaracaoIR === 'I' ? 'Isento' : 'Não'} <br/>
                        <strong>Renda Familiar Bruta:</strong> {rendaFamiliarBruta.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} <br/>
                        <strong>Renda Agregada (Pensão):</strong> {rendaAgregada.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} <br/>
                        <strong>Renda Bruta Total:</strong> {rendaBrutaTotal.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} <br/>
                        <strong>Integrantes no Domicílio:</strong> {totalIntegrantes} <br/>
                        <strong>Renda Per Capita:</strong> {rendaPerCapita.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })} <br/>
                        <strong>CadÚnico / Bolsa Família:</strong> {data.cadUnicoOuTransferenciaRenda ? 'Sim' : 'Não'}
                    </Typography>
                </LabelValue>
            </div>
            <Divider className={classes.divider} />
            <div className={classes.marginBottom}>
                <LabelValue label='Dados do Curso'>
                    <Typography variant="body1">
                        <strong>Curso de Interesse:</strong> {data.vaga?.descricao || 'Não selecionado'} <br/>
                        <strong>Cotas:</strong> {data.sistemaCotas ? 'Sim' : 'Não'}
                    </Typography>
                </LabelValue>
            </div>
        </BoxOpcoes>
    );
}
